
const BuyerPricingFAQ = () => {
  const faqs = [
    {
      question: "Is it really free?",
      answer: "Yes, buyer accounts are completely free. No subscription, no trial period, no credit card required."
    },
    {
      question: "Do I need a credit card to sign up?",
      answer: "No. Just create your account, verify your email, and start browsing properties immediately — no payment information needed."
    },
    {
      question: "Will I be charged later?",
      answer: "No. Buyer access is free — there is no trial that converts to a paid plan and no hidden fees."
    },
    {
      question: "How many properties can I save?",
      answer: "You can save unlimited properties and create up to 8 custom saved searches to track new opportunities."
    },
    {
      question: "Can I follow multiple sellers?",
      answer: "Yes, you can follow unlimited sellers and receive notifications when they list new properties matching your criteria."
    }
  ];

  return (
    <section className="py-16 bg-gray-900/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold">Frequently Asked Questions</h2>
        </div>
        <div className="max-w-3xl mx-auto grid gap-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-gray-800 p-6 rounded-lg border border-gray-700">
              <h3 className="text-xl font-semibold mb-2">{faq.question}</h3>
              <p className="text-gray-300">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BuyerPricingFAQ;
